module.exports = __webpack_public_path__ + "3760aebedea81750fbc6b907567a268e.svg";